import { ApolloClient, InMemoryCache } from '@apollo/client';
import typePolicies from './typePolicies';
import link from './apolloLink';

const client = new ApolloClient({
  ssrMode: true,
  link: link(),
  cache: new InMemoryCache({
    typePolicies,
  }),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
});

export default client;
